import React, { useState } from "react";
import styles from "../Sidebar.module.scss";
import { useLocation, useNavigate } from "react-router";
import { clear } from "Service/storage";
import cn from "classnames";
import Icon from "@ant-design/icons";
import { UpOutlined, DownOutlined } from "@ant-design/icons";

type SidebarItemProps = {
  index: number;
  sidebarItem: any;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const SidebarItem: React.FC<SidebarItemProps> = ({
  sidebarItem,
  index,
  open,
  setOpen,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showSubNav, setShowSubNav] = useState(false);

  const handleUnitsClick = () => {
    setShowSubNav(!showSubNav);
  };

  const handleClick = (link: string) => {
    if (link === "/addload") {
      setOpen(true);
      return;
    }

    if (link === "/sign-in") clear("token");

    navigate(link);
  };

  const renderSubNav = (
    subNav: { name: string; link: string }[] | undefined
  ) => {
    if (!showSubNav || !subNav) return null;

    return (
      <ul className={styles.sidebar__subnav}>
        {subNav.map((subNavItem, index) => (
          <li
            key={index}
            className={cn(
              styles.sidebar__subnav__item,
              pathname.includes(subNavItem.link) &&
                styles.sidebar__items__item_active
            )}
            onClick={() => handleClick(subNavItem.link)}
          >
            {subNavItem.name}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <li
      key={index}
      className={cn(
        styles.sidebar__items__item,
        pathname.includes(sidebarItem.link) &&
          styles.sidebar__items__item_active
      )}
      onClick={() => handleClick(sidebarItem.link)}
    >
      <div className={styles.sidebar__items__item__icons}>
        <p>
          <Icon component={sidebarItem.icon} />
        </p>
        {sidebarItem.subNav ? (
          <span
            className={cn(styles.sidebar__items__item__text, {
              [styles.sidebar__items__item_active]: showSubNav,
            })}
            onClick={handleUnitsClick}
          >
            {sidebarItem.name}{" "}
            <Icon
              component={
                showSubNav
                  ? (UpOutlined as React.ComponentType<
                      React.SVGProps<SVGSVGElement>
                    >)
                  : (DownOutlined as React.ComponentType<
                      React.SVGProps<SVGSVGElement>
                    >)
              }
            />
          </span>
        ) : (
          <span className={styles.sidebar__items__item__text}>
            {sidebarItem.name}
          </span>
        )}
      </div>
      <div className={styles.sidebar__items__item__subnav}>
        {renderSubNav(sidebarItem.subNav)}
      </div>
    </li>
  );
};
export default SidebarItem;
